import { getToken } from 'src/utils/helper';
import axios from '../../../utils/axios';
import { createSlice } from '@reduxjs/toolkit';

// API of userList
const USER_LIST = `${process.env.REACT_APP_BASE_URL}/users`;
const GET_USER_BY_ID = `${process.env.REACT_APP_BASE_URL}/admin/users/by-id`;
const ADD_USER = `${process.env.REACT_APP_BASE_URL}/admin/users/add`;
const UPDATE_USER = `${process.env.REACT_APP_BASE_URL}/admin/users/update`;
const DELETE_USER = `${process.env.REACT_APP_BASE_URL}/admin/users/delete`;

const token = localStorage.getItem('loginToken');

const initialState = {
  data: [],
  userData: {},
  status: null,
  message: null,
};

export const UserListSlice = createSlice({
  name: 'UserList',
  initialState,
  reducers: {
    userListSuccess: (state, action) => {
      state.userData = action.payload.userData;
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    userListFailure: (state, action) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
    },

    userDetailsSuccess: (state, action) => {
      state.userData = action.payload.userData;
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    userDetailsFailure: (state, action) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
    },

    addUserSuccess: (state, action) => {
      state.data = action.payload.data;
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    addUserFailure: (state, action) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
    },

    updateUserSuccess: (state, action) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    updateUserFailure: (state, action) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
    },

    deleteUserSuccess: (state, action) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    deleteUserFailure: (state, action) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
  },
});

export const {
  userListSuccess,
  userListFailure,
  userDetailsSuccess,
  userDetailsFailure,
  addUserSuccess,
  addUserFailure,
  updateUserSuccess,
  updateUserFailure,
  deleteUserSuccess,
  deleteUserFailure,
} = UserListSlice.actions;

export const fetchUserList = (page = 1, pageSize = 20, referredBy = '') => async (dispatch) => {
  const token = getToken();
  try {
    const params = {
      page,
      pageSize,
      ...(referredBy && { referredBy }) // Only add referred_by if it has a value
    };

    const response = await axios.get(`${USER_LIST}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params
    });

    if (response.data.status) {
      await dispatch(
        userListSuccess({
          status: response.data.status,
          message: response.data.message,
          userData: response.data.data,
        }),
      );
    } else {
      dispatch(
        userListFailure({
          status: false,
          message: response.data.message || 'Failed to fetch users',
        }),
      );
    }

    return response.data;
  } catch (error) {
    dispatch(
      userListFailure({
        status: false,
        message: error.message || 'An error occurred while fetching users',
      }),
    );
    console.error('Error fetching user list:', error);
    throw error;
  }
};

export const getUserByID = (id) => async (dispatch) => {
  try {
    const response = await axios.get(`${GET_USER_BY_ID}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    await dispatch(
      userDetailsSuccess({
        status: response.data.status,
        message: response.data.message,
        userData: response.data.data,
      }),
    );

    return response?.data;
  } catch (error) {
    dispatch(
      userDetailsFailure({
        status: false,
        message: error.message,
      }),
    );
  }
};

export const addUser = (userData) => async (dispatch) => {
  try {
    const response = await axios.post(ADD_USER, JSON.stringify(userData), {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(
      addUserSuccess({
        status: response.data.status,
        message: response.data.message,
      }),
    );
    dispatch(fetchUserList());
    return response?.data;
  } catch (error) {
    dispatch(
      addUserFailure({
        status: false,
        message: error.message,
      }),
    );
  }
};

export const updateUser = (id, data) => async (dispatch) => {
  try {
    const response = await axios.put(`${UPDATE_USER}/${id}`, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(
      updateUserSuccess({
        status: response.data.status,
        message: response.data.message,
      }),
    );
    dispatch(getUserByID(id));
    dispatch(fetchUserList());
    return response?.data;
  } catch (error) {
    dispatch(
      updateUserFailure({
        status: false,
        message: error.message,
      }),
    );
  }
};

export const deleteUser = (id) => async (dispatch) => {
  try {
    const response = await axios.delete(`${DELETE_USER}/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(
      deleteUserSuccess({
        status: response.data.status,
        message: response.data.message,
      }),
    );
    dispatch(fetchUserList());
    return response?.data;
  } catch (error) {
    dispatch(
      deleteUserFailure({
        status: false,
        message: error.message,
      }),
    );
  }
};

export default UserListSlice.reducer;
